/* eslint-disable */
import './style.scss';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Select, Table, Tag, Spin,Input } from 'antd';
import { ColumnsType } from 'antd/es/table';

import ApiService from '@services/api.service';
import moment from 'moment';
import { cloneDeep, remove, uniqBy } from 'lodash';
import { toast } from 'react-toastify';
import { useOutletContext } from 'react-router-dom'
import { SearchOutlined } from '@ant-design/icons';
import { DeleteOutlined } from '@ant-design/icons';

interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
}
const { Option } = Select;
function Users() {
    const [searchResults, setSearchResults] = useState<any>([]);
    const [tempSearchResults, setTempSearchResults] = useState<any>([]);
    const [medicalPractices, setMedicalPractices] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDropdownValue, setSelectDropdownValue] = useState<string>();
    const [usersColumns, setUsersColumns] = useState<ColumnsType<DataType>>();
    const [currentUser,setCurrentUser]:any = useState()
    
    const [title, setTitle] = useState<string>();
    const [total, setTotal] = useState<number>(0);
    const [rerender, setRerender] = useState<boolean>(false);
    const [toggleAccessLoading, setToggleAccessLoading] = useState<null | number>(null);
    const { user }:any = useOutletContext()
    const [sort, setSort] = useState({
        field: "name",
        order: "asc", // 'ascend' or 'descend'
        });
    var columns: ColumnsType<DataType>;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [search, setSearch] = useState(false);
    const [ascSort, setAcsSort] = useState(false);
    const [desSort, setDesSort] = useState(false);

    columns = [
        {
            title: 'ID',
            width: 80,
            dataIndex: 'id',
            key: "id", 
            sorter: true, 
        },
        {
            title: 'SID',
            width: 80,
            key: "medicalPractice.subscriptionId", 
            render: (row) => {
                return row?.medicalPractice?.subscriptionId
            },
            sorter: true,
        },
        {
            title: 'Name',
            key: "name", 
            render: (row) => (
                `${row?.name} ${row?.surname}`
            ),
            sorter: true,
        },
        {
            title: 'Email',
            key: "email", 
            render: (row) => (
                row?.email
            ),
            sorter: true,
        },
        {
            title: 'Practice Name',
            key: "medicalPractice.practiceName", 
            render: (row) => (
                row?.medicalPractice?.practiceName
            ),
            sorter: true,
        },
        {
            title: 'Role',
            key:'roleId',
            render: (row) => (
                <div>
                    {row?.roleId === 1 && <Tag color="#CAE2CD" style={{ color: '#40916C' }}>Learner</Tag>}
                    {row?.roleId === 2 && <Tag color="#E4CFE1" style={{ color: '#84568E' }}>Leader</Tag>}
                    {row?.roleId === 3 && <Tag color="#2db7f5" style={{ color: '#000000' }}>Super Admin</Tag>}
                </div>
            ),
            sorter: true,
        },
        {
            title: 'Last Logged In',
            render: (row) => (
                row?.lastLoggedIn ? moment(row?.lastLoggedIn).startOf('hour').fromNow() : 'No Logins Yet'
            ),
            key:'lastLoggedIn',
            sorter: true,
        },
        {
            title: ' ',
            key:'btn',
            render: (row) => {
                return ToggleAccessBtn(row);
            },
            // sorter: true,
        },
    ];

    useEffect(() => {
        setUsersColumns(columns);
        ApiService.getProfile().then(({data}:any) => {
                setCurrentUser(data?.data?.profile)
            }).catch((error) => {
            })
    }, []);

    const ToggleAccessBtn = (row: any) => { 
        return <Button loading={toggleAccessLoading === row.id} onClick={() => { doToggleAccess(row) }} style={{ color: row?.roleId === 1 ? '#84568E' : '#40916C' }} type="link">Assign as {row?.roleId === 1 ? 'Leader' : 'Learner'}</Button>
    };
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [paginationPractice, setPaginationPractice] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const doToggleAccess = (row: any) => {
        setToggleAccessLoading(row.id);
        ApiService.toggleAccess(row.id).then((response) => {
            toast.success("User role updated successfully", {
                position: "top-right",
            });
            setToggleAccessLoading(null);
            fetchUsers(pagination.current, pagination.pageSize,'id', 'asc');
        }).catch((error) => {
            setToggleAccessLoading(null);
        });
    };

    // const fetchActivePractices = useCallback(() => {
    //     setIsLoading(true);

    //     ApiService.getPractices().then((response) => {
    //         if (response?.data) {
    //             const practicesOptions = [
    //                 {
    //                     id: 'all',
    //                     practiceName: 'All Practices',
    //                 },
    //                 ...response.data
    //             ];

    //             setMedicalPractices(practicesOptions);
    //             setSelectDropdownValue('all');
    //             updateSectionTitle('all');
    //         };

    //         setIsLoading(false);
    //     }).catch((error) => {
    //         setIsLoading(false);
    //         console.log('error: ', error);
    //     });
    // }, []);
    

    const fetchData = async (page:any, pageSize:any,sortField:any, sortOrder:any,search='' ) => {
        if ((!hasMore || loading) && search==='' ) 
            return;
        setLoading(true);
        ApiService.getPractices(page,pageSize,'id', {id: "asc"},search).then((response) => {
            if (response?.data?.data) {
                const newData = response?.data?.data?.map((item:any) => ({
                    value: item.id,
                    label: item.practiceName,
                  }));
                  setPaginationPractice((prev) => ({
                    ...prev,
                    current: page+1,
                    total: response.data.total,
                  }));
                  if(search){
                    setData(newData);
                  }else{
                    setData((prevData):any => [...prevData, ...newData]);
                    setHasMore(newData.length > 0); // If no new data, stop loading
                  }
                  setPage(page + 1);
            };
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
        });
      };
      const handlePopupScroll = (e:any) => {
        const { target } = e;
        if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
          fetchData(paginationPractice.current,paginationPractice.pageSize,sort.field, sort.order);
        }
      };

    useEffect(() => {
        fetchUsers(pagination.current,pagination.pageSize,sort.field, sort.order);
        fetchData(paginationPractice.current,paginationPractice.pageSize,sort.field, sort.order);
        // fetchActivePractices();
    }, []);
     // Load initial data on mount
    // Function to fetch more data


    function fetchUsers(page:any, pageSize:any,sortField:any, sortOrder:any) {
        setIsLoading(true);
        ApiService.getProfiles(page,pageSize,sortField,sortOrder,Number(selectedDropdownValue),searchText).then((response) => {
            if (response?.data) {
                setSearchResults(response.data?.data);
                setTempSearchResults(response.data?.data);
                setTotal(response.data.total)
                setPagination((prev) => ({
                    ...prev,
                    current: page,
                    total: response.data.total,
                  }));
            }
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
        });
    }

    const updateSectionTitle = (value: string) => {
        const selectedMedicalPractice = medicalPractices.find((practice: any) => practice.id === value);
        setTitle(selectedMedicalPractice?.practiceName);
    };

    const handleChange = (value: string) => {
        setSelectDropdownValue(value);
        setPagination((prev) => ({
            ...prev,
            current: 1,
          }));
    };

    useEffect(()=>{
        if(selectedDropdownValue){
            fetchUsers(pagination.current, pagination.pageSize,'id', 'asc');
        }
        if(selectedDropdownValue===undefined){
          setData([])
          fetchData(1,paginationPractice.pageSize,sort.field, sort.order);
          fetchUsers(1, pagination.pageSize,'id','asc');
        }
    },[selectedDropdownValue])

    const handleTableChange = (pagination:any,filters:any, sorter:any) => {
        let rem=0;
        if(sorter.column===undefined){
            setSort({ field: 'name', order: 'asc' });
            fetchUsers(pagination.current, pagination.pageSize,'name', 'asc');
            setDesSort(false)
            setAcsSort(false)
        }else{
            if(sorter.order==='descend'){
                if(desSort===false){
                    fetchUsers(1, pagination.pageSize,sorter.column.key,'desc');
                    setDesSort(true)
                }else{
                    if(sorter.column.key!==sort.field){
                        fetchUsers(1, pagination.pageSize,sorter.column.key,'desc');
                    }else{
                        fetchUsers(pagination.current, pagination.pageSize,sorter.column.key,'desc');
                    }
                }
                setSort({ field: sorter.column.key, order: sorter.order });
            }
            if(sorter.order==='ascend'){
                if(ascSort===false){
                    fetchUsers(1, pagination.pageSize,sorter.column.key,'asc');
                    setAcsSort(true)
                }else{
                    if(sorter.column.key!==sort.field){
                        fetchUsers(1, pagination.pageSize,sorter.column.key,'asc');
                    }else{
                        fetchUsers(pagination.current, pagination.pageSize,sorter.column.key,'asc');
                    }
                }
                setSort({ field: sorter.column.key, order: sorter.order });
            }

        }
    };
    let debounceTimer: ReturnType<typeof setTimeout>;
    const roleBasedColumns:any = {
        3: columns, // Admin sees all
        4: columns.filter((col:any) => !["btn"].includes(col.key)), // Editor cannot see Salary
      };
      const handleSearch = () => {
        if(searchText!==''){
            setSearch(true)
            setPagination((prev) => ({
                ...prev,
                current: 1,
                }));
            fetchUsers(1, pagination.pageSize,'id', 'asc');
         }
      };
      const clearSearch = () => {
        setSearchText('')
        // setSelectDropdownValue(undefined)
        setPagination((prev) => ({
            ...prev,
            current: 1,
          }));
      };
      useEffect(()=>{
        if(searchText==='' &&  search===true){
            setSearch(false)
            fetchUsers(1, pagination.pageSize,'id', 'asc');
        }
      },[searchText,search])

      const handleSearchSelect = (value:any) =>{
        setHasMore(true)
        if(value===''){
            setData([])
            fetchData(1, paginationPractice.pageSize, sort.field, sort.order, value);
        }else{
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                fetchData(1, paginationPractice.pageSize, sort.field, sort.order, value);
            }, 500);
        }
      }

    return (
        <div className="users-container">
            <div className="section-header">
                <div className="title">
                    {total > 0 && <h2 className="section-title">{title} ({total})</h2>}
                </div>

                <div className="practice-dropdown-container">
                    {/* <Select
                        loading={isLoading}
                        value={selectedDropdownValue}
                        style={{ width: 200 }}
                        onChange={handleChange}
                        fieldNames={{ label: 'practiceName', value: 'id' }}
                        options={medicalPractices}
                    /> */}
                        <Select
                        showSearch
                        allowClear
                        value={selectedDropdownValue}
                        placeholder="Select Practice"
                        optionFilterProp="label"
                        style={{ width: "200px" }}
                        onChange={handleChange}
                        filterOption={false}
                        onSearch={handleSearchSelect}
                        loading={loading}
                        onPopupScroll={handlePopupScroll} // Infinite scrolling inside dropdown
                        dropdownRender={(menu) => (
                            <>
                            {menu}
                            {loading && (
                                <div style={{ textAlign: "center", padding: "8px" }}>
                                <Spin size="small" />
                                </div>
                            )}
                            </>
                        )}
                        >&nbsp;&nbsp;
                        {data.map((item:any,index:any) => (
                            <Option key={index} value={item.value}>
                            {item.label}
                            </Option>
                        ))}
                        </Select>&nbsp;&nbsp;
                        <Input
                        placeholder="Search..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: '200px', marginRight: 8 }}
                        />
                        <Button type="primary"  style={{height:"31.6px"}} icon={<SearchOutlined rev={undefined} />} onClick={handleSearch}>Search</Button>&nbsp;&nbsp;
                        <Button onClick={clearSearch} style={{height:"31.6px"}} icon={<DeleteOutlined rev={undefined} />} >Clear</Button>&nbsp;&nbsp;
                </div>
            </div>

            <div className="table-container">
                {!rerender && <Table
                    bordered
                    key="id"
                    loading={isLoading}
                    columns={roleBasedColumns[currentUser?.roleId]}
                    dataSource={searchResults}
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: pagination.total,
                        showSizeChanger: false,
                        }}
                    scroll={{ y: 'calc(100vh - 270px)', x: 100 }}
                    onChange={handleTableChange}
                />}

                {rerender && <Table loading />}
            </div>
        </div>
    );
}

export default Users;